<script>
    export default {
        name: "ProductCardPrice",
        props: {
            oldPrice: Number,
            price: Number,
            discountCount: Number,
        },
    };
</script>

<template>
    <div class="product-card-price">
        <div class="product-card-price__number" :class="{ 'is-discount': discountCount }">
            {{ price | formatPrice }}&nbsp;<span class="currency-ruble">₽</span>
        </div>
        <div v-if="discountCount" class="product-card-price__old">
            {{ oldPrice | formatPrice }}&nbsp;<span class="currency-ruble">₽</span>
        </div>
    </div>
</template>

<style lang="scss">
    .product-card-price {
        display: flex;
        align-items: center;
        @include bp($bp-desktop-sm) {
            display: block;
        }
    }

    .product-card-price__number {
        color: var(--primary-text);
        font-family: var(--secondary-font);
        font-size: 24px;
        font-weight: 500;
        line-height: 24px;
        letter-spacing: 0.03em;
        @include bp($bp-desktop-sm) {
            font-size: 40px;
            line-height: 40px;
            letter-spacing: 0;
        }
    }

    .product-card-price__old {
        margin-left: 20px;
        color: #b0b0b0;
        font-size: 18px;
        line-height: 24px;
        text-decoration: line-through;
        @include bp($bp-desktop-sm) {
            margin-top: 16px;
            margin-left: 0;
        }
    }
</style>
